export default class Locale {
	constructor(language, region, i18n) {

		var acceptedRFC5646Locales = Object.keys(i18n.messages);

		var newLanguage = undefined;
		var newRegion = undefined;

		if(language && region && !acceptedRFC5646Locales.includes(this.toRFC5646(language, region))) {
			var localeMatchLanguage = acceptedRFC5646Locales.find(locale => locale.toLowerCase().substr(0, 2) === language.toLowerCase());
			if(localeMatchLanguage) { newLanguage = localeMatchLanguage.substr(0,2); newRegion = localeMatchLanguage.substr(3,2); }
			else {
				var localeMatchRegion = acceptedRFC5646Locales.find(locale => locale.toLowerCase().substr(3, 2) === region.toLowerCase());
				if(localeMatchRegion) { newLanguage = localeMatchRegion.substr(0,2); newRegion = localeMatchRegion.substr(3,2); }
			}
		}

		if(language && region && acceptedRFC5646Locales.includes(this.toRFC5646(language, region))) {
			newLanguage = language; newRegion = region;
		}

		this.language = (newLanguage || acceptedRFC5646Locales[0].substr(0,2)).toLowerCase();
		this.region = (newRegion || acceptedRFC5646Locales[0].substr(3,2)).toLowerCase();
		this.i18n = i18n;
	}

	toRFC5646(language, region) {
		return [language || this.language, (region || this.region).toUpperCase()].join("-");
	}

	toString(separator) {
		return [this.language, this.region].join(separator);
	}

	toRouteLinkProp(routeName, forcedLanguage, forcedRegion, partialPath) {
		return {
			path:
				"/" + (forcedLanguage ? forcedLanguage : this.language) +
				"/" + (forcedRegion ? forcedRegion : this.region) +
				"/" + (routeName === undefined ? partialPath.replace(/^\/|\/$/g, '') : this.i18n.t('routes.' + routeName, (forcedLanguage && forcedRegion) ? this.toRFC5646(forcedLanguage, forcedRegion) : undefined))
		};
	}

	static getLocaleFromService (i18n) {
		return new Promise((resolve, reject) => {
			var browserLocale = navigator.userLanguage || navigator.language;
			var browserLanguage = browserLocale.length === 2 || browserLocale.length === 5 ? browserLocale.substr(0, 2) : undefined;

			var xhr = new XMLHttpRequest();
			xhr.onload = () => {
				if(xhr.status === 200) resolve(new this(browserLanguage, xhr.response.country, i18n));
				reject();
			};
			xhr.onerror = () => reject();
			xhr.ontimeout = () => reject();
			xhr.open("GET", "https://ipapi.co/json/?key=f90aa8f27b7cfd81d5d483eab492cace598116a7", true);
			xhr.responseType = 'json';
			xhr.timeout = 1250;
			xhr.send();
		});
	}
}